//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').service('ProductFeedHealthService', [
    'rx',
    'ProductFeedHealthApiService',
    function(
            rx,
            ProductFeedHealthApiService,
        ) {
      const self = this;

      self.isInitialized = false;

            /**
             * RxJS subjects.
             */
      self.metadataStream = new rx.Subject();
      self.historyStream = new rx.Subject();
      self.feedOverviewStream = new rx.Subject();

      self.getMetadata = function() {
        return self.metadataStream.asObservable();
      };

      self.getHistory = function() {
        return self.historyStream.asObservable();
      };

      self.getFeedOverview = function() {
        return self.feedOverviewStream.asObservable();
      };

      self.changeCatalogId = function(catalogId) {
        self.initialize(catalogId);
      };

      self.initialize = function(catalogId) {
        self.isInitialized = true;
        rx.Observable.fromPromise(ProductFeedHealthApiService.getOverviewItems())
                    .do((overviewItemsResponse) => {
                      self.feedOverviewStream.next(overviewItemsResponse);
                    })
                    .map(overviewItemsResponse => catalogId || _(overviewItemsResponse.items).findWhere({ isDefault: true }).catalogId)
                    .subscribe((catalogResponse) => {
                      rx.Observable.fromPromise(ProductFeedHealthApiService.getFeedMetadata(catalogResponse))
                            .subscribe((metadataResponse) => {
                              self.metadataStream.next(metadataResponse);
                            });
                      rx.Observable.fromPromise(ProductFeedHealthApiService.getHistoryItems(catalogResponse))
                            .subscribe((historyItemsResponse) => {
                              self.historyStream.next(historyItemsResponse);
                            });
                    });
      };
    }]);
})();
